export default "__VITE_ASSET__CrQJrndi__"